import React, { useEffect, useState } from 'react';
import CustomCard from '../../../components/CustomCard';
import Form from '../../../components/form/Form';
import EditableSection from '../../../components/form/EditableSection';
import PaymentFormConfig from './PaymentFormConfig';
import InvoiceFormConfig from './InvoiceFormConfig';
import PaymentOnBookingFormConfig from './PaymentOnBookingFormConfig';
import Percentage from '../../../components/lakeview/Percentage';
import Price from '../../../components/lakeview/Price';
import SecurityDepositFormConfig from './SecurityDepositFormConfig';

const PaymentSection = ({
  offerResult,
  paymentSelections,
  setPaymentSelections,
  paymentOnBookingPercentage,
  securityDepositAmount,
  setPaymentReady,
  updatePaymentOnBookingPercentage,
  updateSecurityDepositAmount,
}) => {
  const [versionKey, setVersionKey] = useState(Date.now());
  const [securityDepositAmountVersionKey, setSecurityDepositAmountVersionKey] = useState(Date.now());
  const [paymentFormReady, setPaymentFormReady] = useState(false);

  const handleSave = (data) => {
    updatePaymentOnBookingPercentage(data);
    setVersionKey(Date.now());
  };

  const handleSaveSecurityDeposit = (data) => {
    updateSecurityDepositAmount(data);
    setSecurityDepositAmountVersionKey(Date.now());
  };

  const updateInvoiceSelections = (data) => {
    if (!data) return;

    setPaymentSelections((prev) => ({
      ...prev,
      ...data
    }));
  };

  useEffect(() => {
    setPaymentReady(paymentFormReady);
  }, [paymentFormReady, setPaymentReady]);

  if (!offerResult?.result?.paymentSummary) return null;

  const invoiceSummary = (
    <>
      <div>{paymentSelections?.needInvoice ? 'Tak' : 'Nie'}</div>
      {paymentSelections?.needInvoice && (
        <>
          <div>{paymentSelections?.invoiceName || '-'}</div>
          <div>{paymentSelections?.invoiceNip || '-'}</div>
          <div>{paymentSelections?.invoiceAddress || '-'}</div>
        </>
      )}
    </>
  );

  return (
    <CustomCard shadow={false} title="Płatność">
      <Form
        shadow={false}
        fields={PaymentFormConfig}
        width={12}
        initialData={paymentSelections}
        formDataChanged={(data) => {
          if (!data) return;
          setPaymentSelections((prev) => ({
            ...prev,
            ...data
          }));
        }}
        onReadyUpdate={setPaymentFormReady}
        noActions={true}
      />
      <EditableSection
        label="Czy potrzebuję faktury?"
        showSummary={paymentSelections?.needInvoice !== undefined}
        summaryContent={invoiceSummary}
        showSave={true}
      >
        <Form
          shadow={false}
          fields={InvoiceFormConfig}
          width={12}
          initialData={paymentSelections}
          formDataChanged={updateInvoiceSelections}
          noActions={true}
        />
      </EditableSection>
      <EditableSection
        key={securityDepositAmountVersionKey}
        label="Kaucja"
        showSummary={!!securityDepositAmount}
        summaryContent={<Price value={securityDepositAmount} />}
      >
        <Form
          key={offerResult.result.paymentSummary.total}
          shadow={false}
          fields={SecurityDepositFormConfig}
          width={12}
          initialData={{
            securityDepositAmount
          }}
          customSave={handleSaveSecurityDeposit}
          withoutCancel={true}
        />
      </EditableSection>

      {paymentSelections?.paymentModel === 'PARTIAL_PAYMENT' && (
        <EditableSection
          key={versionKey}
          label="Zaliczka przy rezerwacji"
          showSummary={!!paymentOnBookingPercentage}
          summaryContent={<Percentage value={paymentOnBookingPercentage} />}
        >
          <Form
            key={offerResult.result.paymentSummary.total}
            shadow={false}
            fields={PaymentOnBookingFormConfig}
            width={12}
            initialData={{
              paymentOnBookingPercentage,
              total: offerResult.result.paymentSummary.total,
            }}
            customSave={handleSave}
            withoutCancel={true}
          />
        </EditableSection>
      )}
    </CustomCard>
  );
};

export default PaymentSection;
